import { createEnum } from '../helpers'

// Business-rule error keys for the vacation endpoints. Emitted as a ZodIssue `params.type` so the
// frontend can translate them (the value matches the i18n key under `userSheet.vacations.errors`).
export const USER_VACATION_ERRORS = [
  // The end date falls before the start date.
  'vacationEndBeforeStart',
  // The vacation would end before today: past vacations are history and cannot be entered or kept.
  'vacationInPast',
  // The vacation ended before today, so it can no longer be edited or deleted.
  'vacationLocked',
  // The vacation already started: its start date is history and cannot move.
  'vacationStartLocked',
  // The dates overlap a vacation that already ended, which is history and cannot be merged into.
  'vacationOverlaps',
] as const
export const USER_VACATION_ERROR_TYPES = createEnum(USER_VACATION_ERRORS)
export type UserVacationErrorType = (typeof USER_VACATION_ERRORS)[number]
